module.exports = __webpack_public_path__ + "img/ic_room_store_data_right_img.d426845c.png";